import type { DocumentationDraft } from "./models";

type ConversationTurn = NonNullable<DocumentationDraft["conversation_turns"]>[number];

/**
 * An unresolved clarification belongs after the existing card. Once the user
 * answers it (or makes a normal revision), the newly produced card belongs
 * after the completed conversation turns that caused it.
 */
export function shouldRenderConversationBeforeCards(turns: readonly ConversationTurn[]): boolean {
    if (turns.length === 0) return false;
    return turns[turns.length - 1]?.kind !== "workflow_change_clarification";
}
